import type { Data } from '@/api/api.ts'
import type {
  Caller,
  CallerPlaces,
  CallersGroup,
  UserCaller,
  UserCallersGroup,
  UserInfo,
} from '@/types/massAddCallers.types.ts'
import type { PhoneType } from '@/types/types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}stafftools/`

export const getUserInfo = async (userId: number): Promise<Data<UserInfo>> => {
  return axios.get(`${urlPrefix}users/${userId}/`)
}

export const getCallerPlaces = async (userId: number): Promise<Data<CallerPlaces>> => {
  return axios.get(`${urlPrefix}callers/places/`, { params: { user_id: userId } })
}

export const getShowcaseCallers = async (
  userId: number,
  areaId: number,
  phoneType: PhoneType,
  count: number,
): Promise<Data<Caller[]>> => {
  const params = { user_id: userId, caller_place_id: areaId, phone_type: phoneType, count: count }

  return axios.get(`${urlPrefix}callers/showcase/`, { params })
}

export const getShowcaseCallersGroups = async (userId: number, count: number): Promise<Data<CallersGroup[]>> => {
  const params = { user_id: userId, count: count }

  return axios.get(`${urlPrefix}callers/groups/showcase/`, { params })
}

export const getCallers = async (
  userId: number,
  fromDate: string | null,
  toDate: string | null,
  page: number,
): Promise<Data<UserCaller[]>> => {
  const params = { user_id: userId, from_date: fromDate, to_date: toDate, page: page }

  return axios.get(`${urlPrefix}callers/`, { params })
}

// TODO: rename phones -> callers
export const addCallers = async (userId: number, isFree: boolean, callers: Caller[]): Promise<Data<object>> => {
  const params = { user_id: userId, is_free: Number(isFree) }

  return axios.post(`${urlPrefix}callers/`, { callers }, { params: params })
}

export const removeCallers = async (userId: number, makeShowcase: boolean, ids: number[]): Promise<Data<object>> => {
  const params = { user_id: userId, make_showcase: Number(makeShowcase) }

  return axios.delete(`${urlPrefix}callers/`, { data: { ids }, params })
}

export const getCallersGroups = async (
  userId: number,
  fromDate: string | null,
  toDate: string | null,
  page: number,
): Promise<Data<UserCallersGroup[]>> => {
  const params = { user_id: userId, from_date: fromDate, to_date: toDate, page: page }

  return axios.get(`${urlPrefix}callers/groups/`, { params })
}

export const addCallersGroups = async (
  userId: number,
  isFree: boolean,
  callersGroups: CallersGroup[],
): Promise<Data<object>> => {
  const params = { user_id: userId, is_free: Number(isFree) }

  return axios.post(`${urlPrefix}callers/groups/`, { caller_groups: callersGroups }, { params: params })
}

export const removeCallersGroups = async (
  userId: number,
  makeShowcase: boolean,
  ids: number[],
): Promise<Data<object>> => {
  const params = { user_id: userId, make_showcase: Number(makeShowcase) }

  return axios.delete(`${urlPrefix}callers/groups/`, { data: { ids }, params })
}
